var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.config_name"),
                  placeholderValue: _vm.$t("common.routing.config_name"),
                },
                model: {
                  value: _vm.name,
                  callback: function ($$v) {
                    _vm.name = $$v
                  },
                  expression: "name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.brokers_domain"),
                  placeholderValue: _vm.$t("common.routing.brokers_domain"),
                },
                model: {
                  value: _vm.brokersDomain,
                  callback: function ($$v) {
                    _vm.brokersDomain = $$v
                  },
                  expression: "brokersDomain",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.brokers_port"),
                  placeholderValue: _vm.$t("common.routing.brokers_port"),
                },
                model: {
                  value: _vm.brokersPort,
                  callback: function ($$v) {
                    _vm.brokersPort = $$v
                  },
                  expression: "brokersPort",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.topic"),
                  placeholderValue: _vm.$t("common.routing.topic"),
                },
                model: {
                  value: _vm.topic,
                  callback: function ($$v) {
                    _vm.topic = $$v
                  },
                  expression: "topic",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.login && _vm.password
        ? _c(
            "form-accordion",
            { attrs: { title: "Token credentials", isTitleUpperCase: false } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "fake-hr-right px-0", attrs: { cols: "6" } },
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "form-write-group-label-input",
                            {
                              attrs: {
                                disabled: true,
                                maxLength: 512,
                                inputType: "select",
                                inputLabel: _vm.$t(
                                  "common.routing.loginStorage"
                                ),
                              },
                              model: {
                                value: _vm.loginStorage,
                                callback: function ($$v) {
                                  _vm.loginStorage = $$v
                                },
                                expression: "loginStorage",
                              },
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.loginStorage,
                                      expression: "loginStorage",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { disabled: true },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.loginStorage = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("common.routing.volume_select")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "PEM" } }, [
                                    _vm._v(_vm._s("PEM")),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "FILE" } }, [
                                    _vm._v(_vm._s("Volume")),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "Vault" } }, [
                                    _vm._v(_vm._s("Vault")),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      disabled: true,
                                      maxLength: 512,
                                      inputLabel: _vm.$t(
                                        "common.routing.loginFile"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.routing.loginFile"
                                      ),
                                    },
                                    model: {
                                      value: _vm.loginFile,
                                      callback: function ($$v) {
                                        _vm.loginFile = $$v
                                      },
                                      expression: "loginFile",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("label", [_vm._v("Variable")]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-radio-group",
                                    {
                                      attrs: { disabled: true },
                                      model: {
                                        value: _vm.loginFileType,
                                        callback: function ($$v) {
                                          _vm.loginFileType = $$v
                                        },
                                        expression: "loginFileType",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "variableP12PwdInsideFile-radio",
                                            value: "ENV",
                                          },
                                        },
                                        [_vm._v("ENV")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "variableP12PwdInsideFile-radio",
                                            value: "OTHER",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("common.other")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      disabled: true,
                                      maxLength: 512,
                                      inputLabel: _vm.$t(
                                        "common.routing.loginYAML"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.routing.loginYAML"
                                      ),
                                    },
                                    model: {
                                      value: _vm.loginYAML,
                                      callback: function ($$v) {
                                        _vm.loginYAML = $$v
                                      },
                                      expression: "loginYAML",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("label", [_vm._v("Variable")]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-radio-group",
                                    {
                                      attrs: { disabled: true },
                                      model: {
                                        value: _vm.loginYAMLType,
                                        callback: function ($$v) {
                                          _vm.loginYAMLType = $$v
                                        },
                                        expression: "loginYAMLType",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "variableP12PwdInsideFile-radio",
                                            value: "ENV",
                                          },
                                        },
                                        [_vm._v("ENV")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "variableP12PwdInsideFile-radio",
                                            value: "OTHER",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("common.other")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "px-0", attrs: { cols: "6" } },
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "form-write-group-label-input",
                            {
                              attrs: {
                                disabled: true,
                                maxLength: 512,
                                inputType: "select",
                                inputLabel: _vm.$t(
                                  "common.routing.passwordStorage"
                                ),
                              },
                              model: {
                                value: _vm.passwordStorage,
                                callback: function ($$v) {
                                  _vm.passwordStorage = $$v
                                },
                                expression: "passwordStorage",
                              },
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.loginStorage,
                                      expression: "loginStorage",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { disabled: true },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.loginStorage = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("common.routing.volume_select")
                                      ) + "..."
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "PEM" } }, [
                                    _vm._v(_vm._s("PEM")),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "FILE" } }, [
                                    _vm._v(_vm._s("Volume")),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "Vault" } }, [
                                    _vm._v(_vm._s("Vault")),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      disabled: true,
                                      maxLength: 512,
                                      inputLabel: _vm.$t(
                                        "common.routing.passwordFile"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.routing.passwordFile"
                                      ),
                                    },
                                    model: {
                                      value: _vm.passwordFile,
                                      callback: function ($$v) {
                                        _vm.passwordFile = $$v
                                      },
                                      expression: "passwordFile",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("label", [_vm._v("Variable")]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-radio-group",
                                    {
                                      attrs: { disabled: true },
                                      model: {
                                        value: _vm.passwordFileType,
                                        callback: function ($$v) {
                                          _vm.passwordFileType = $$v
                                        },
                                        expression: "passwordFileType",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "variableP12PwdInsideFile-radio",
                                            value: "ENV",
                                          },
                                        },
                                        [_vm._v("ENV")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "variableP12PwdInsideFile-radio",
                                            value: "OTHER",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("common.other")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      disabled: true,
                                      maxLength: 512,
                                      inputLabel: _vm.$t(
                                        "common.routing.passwordYAML"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.routing.passwordYAML"
                                      ),
                                    },
                                    model: {
                                      value: _vm.passwordYAML,
                                      callback: function ($$v) {
                                        _vm.passwordYAML = $$v
                                      },
                                      expression: "passwordYAML",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("label", [_vm._v("Variable")]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-radio-group",
                                    {
                                      attrs: { disabled: true },
                                      model: {
                                        value: _vm.passwordYAMLType,
                                        callback: function ($$v) {
                                          _vm.passwordYAMLType = $$v
                                        },
                                        expression: "passwordYAMLType",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "variableP12PwdInsideFile-radio",
                                            value: "ENV",
                                          },
                                        },
                                        [_vm._v("ENV")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "variableP12PwdInsideFile-radio",
                                            value: "OTHER",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("common.other")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }